import { createVueApp } from "@saflib/vue";
import { setClientName } from "@saflib/links";
import App from "./PowerUpApp.vue";
import "vuetify/styles";
import { router } from "./router.ts";
import { power_up_app_strings } from "./strings.ts";
import {
  vuetifyConfig,
  sentryCallback,
  initClientObservability,
  powerUpMfaRequiredHref,
} from "@vendata/power-up-clients-common";

export const main = () => {
  setClientName("app");
  initClientObservability();
  createVueApp(App, {
    router,
    vuetifyConfig,
    callback: sentryCallback,
    i18nMessages: {
      ...power_up_app_strings,
    },
    mfaRequiredHref: powerUpMfaRequiredHref(),
  });
};
